import AddNewConnectionsPage from "../app/marketingAgent/addConnections";
import AllConnectionsPage from "../app/marketingAgent/allConnections";
import BroadbandInfoPage from "../app/marketingAgent/broadband";
import AgentCalenderPage from "../app/marketingAgent/calender";
import MarketingAgentPage from "../app/marketingAgent/home";
import NewPage from "../app/marketingAgent/newPage";
import AdditionalServicePage from "../app/superadmin/additionalService";
import AdministratorPage from "../app/superadmin/administrators";
import AgentsPage from "../app/superadmin/agents";
import AdminAllConnectionPage from "../app/superadmin/allConnections";
import BroadbandPage from "../app/superadmin/broadband";
import SuperAdminPage from "../app/superadmin/dashboard";
import AdminDiscountPage from "../app/superadmin/discount";
import EquipmentPage from "../app/superadmin/euipment";
import CalendarPageForAdmin from "../app/superadmin/followUps";
import MarkOffDaysPage from "../app/superadmin/markOff";
import ProductPage from "../app/superadmin/product";
import AdminProposalPage from "../app/superadmin/proposals";
import ReportingPage from "../app/superadmin/report";
import ServiceAgrementPage from "../app/superadmin/serviceAgrement";
import LegalContentPage from "../app/superadmin/legalContent";
import AgentSaverDashboard from "../app/marketingAgent/saverDashboard";
import SuperAdminSaverDashboardPage from "../app/superadmin/saverDashboard";
import SuperAdminUpgradeDashboardPage from "../app/superadmin/upgradeDashboard";
import AgentUpgradeDashboard from "../app/marketingAgent/upgradeDashboard";

const AgentRoute = [
  {
    id: 1,
    name: "Dashboard",
    component: <MarketingAgentPage />,
    path: "/",
    icon: "dashboard",
  },
  {
    id: 2,
    name: "Saver Dashboard",
    component: <AgentSaverDashboard />,
    path: "/saver-dashboard",
    icon: "data_saver_off",
  },
  {
    id: 3,
    name: "Upgrade Dashboard",
    component: <AgentUpgradeDashboard />,
    path: "/upgrade-dashboard",
    icon: "upgrade",
  },
  {
    id: 4,
    name: "Add Lead",
    component: <AddNewConnectionsPage />,
    path: "/add-lead",
    icon: "library_add",
  },
  {
    id: 5,
    name: "Prospects",
    component: <AllConnectionsPage />,
    path: "/all-prospects",
    icon: "article",
  },
  {
    id: 6,
    name: "Lead",
    component: <NewPage />,
    path: "/proposals",
    icon: "insert_drive_file",
  },
  {
    id: 7,
    name: "Tariffs Information",
    component: <BroadbandInfoPage />,
    path: "/tariffs",
    icon: "library_add",
  },
  {
    id: 8,
    name: "Calendar",
    component: <AgentCalenderPage />,
    path: "/calendar",
    icon: "calendar_month",
  },
  {
    id: 9,
    name: "Service Agreement",
    component: <ServiceAgrementPage />,
    path: "/service-agrement",
    icon: "handshake",
  },
];

const AdminRoutes = [
  {
    id: 1,
    name: "Dashboard",
    component: <SuperAdminPage />,
    path: "/",
    icon: "dashboard",
  },
  {
    id: 2,
    name: "Saver Dashboard",
    component: <SuperAdminSaverDashboardPage />,
    path: "/saver-dashboard",
    icon: "data_saver_off",
  },
  {
    id: 3,
    name: "Upgrade Dashboard",
    component: <SuperAdminUpgradeDashboardPage />,
    path: "/upgrade-dashboard",
    icon: "upgrade",
  },
  {
    id: 4,
    name: "Prospects",
    component: <AdminAllConnectionPage />,
    path: "/all-prospects",
    icon: "article",
  },

  // {
  //   id: 4,
  //   name: "Import Data",
  //   component: <ImportDataPage />,
  //   path: "/imported-data",
  //   icon: "",
  // },
  {
    id: 5,
    name: "Tariffs",
    component: <BroadbandPage />,
    path: "/broadband",
    icon: "compass_calibration",
  },
  {
    id: 6,
    name: "Additional Services",
    component: <AdditionalServicePage />,
    path: "/additional-service",
    icon: "library_add",
  },
  {
    id: 7,
    name: "Hardware",
    component: <EquipmentPage />,
    path: "/hardware",
    icon: "home_repair_service",
  },
  {
    id: 8,
    name: "Agents",
    component: <AgentsPage />,
    path: "/all-agents",
    icon: "support_agent",
  },
  {
    id: 9,
    name: "Admin",
    component: <AdministratorPage />,
    path: "/administrators",
    icon: "admin_panel_settings",
  },
  {
    id: 10,
    name: "Calendar",
    component: <CalendarPageForAdmin />,
    path: "/calendar",
    icon: "calendar_month",
  },
  {
    id: 11,
    name: "Mark Off Days",
    component: <MarkOffDaysPage />,
    path: "/off-days",
    icon: "calendar_month",
  },
  {
    id: 12,
    name: "Reporting",
    component: <ReportingPage />,
    path: "/reporting",
    icon: "report",
  },
  {
    id: 13,
    name: "Product",
    component: <ProductPage />,
    path: "/product",
    icon: "category",
  },
  {
    id: 14,
    name: "Lead",
    component: <AdminProposalPage />,
    path: "/proposals",
    icon: "edit_note",
  },
  {
    id: 15,
    name: "Discount",
    component: <AdminDiscountPage />,
    path: "/discount",
    icon: "edit_note",
  },
  {
    id: 16,
    name: "Service Agreement",
    component: <ServiceAgrementPage />,
    path: "/service-agrement",
    icon: "handshake",
  },
  {
    id: 17,
    name: "Legal Content",
    component: <LegalContentPage />,
    path: "/legal-content",
    icon: "article",
  },
];

export { AdminRoutes, AgentRoute };
